export default __webpack_public_path__ + "static/media/Salong ett_mixare.726d56d3.jpeg";